<template>
  <div>
    <q-form @submit.prevent="save">
      <q-card>
        <q-card-section>
          <div class="row">
            <div class="col-sm-12">
              <q-btn
                type="submit"
                color="green"
                label="Salvar"
                icon="save"
                class="float-right"
                dense
              />
            </div>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <div class="col-lg-6 col-sm-6 col-xs-12 q-pr-sm">
              <q-input
                ref="inputNome"
                v-model="usuario.nome"
                label="Nome"
                dense
                :rules="[value => !!value || 'Nome é obrigatório']"
                :disable="!isNovo"
              />
            </div>
            <div class="col-lg-6 col-sm-6 col-xs-12 q-pr-sm">
              <q-input
                v-model="usuario.cpf"
                label="CPF"
                dense
                :rules="[
                  value => !!value || 'CPF é obrigatório',
                  cpf => validateCpf(cpf) || 'CPF Inválido'
                ]"
                mask="###.###.###-##"
                unmasked-value
                :disable="!isNovo"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-6 col-xs-12 q-pr-sm">
              <q-input
                v-model="usuario.email"
                label="Email"
                dense
                :rules="[
                  value => !!value || 'Email é obrigatório'
                ]"
                :disable="!isNovo"
              />
            </div>
            <div class="col-lg-6 col-sm-6 col-xs-12 q-pr-sm">
              <q-select
                v-model="usuario.nivel"
                :options="[{ label: 'Administrador', value: 'ADMIN' }, { label: 'Usuário', value: 'USUARIO' }]"
                emit-value
                map-options
                dense
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-12 col-md-6 q-pr-sm">
              <q-checkbox v-model="usuario.habilitado" label="Habilitado" />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-xs-12 q-pr-sm q-pb-sm">
              <q-card>
                <q-card-section>
                  <div class="text-h6">Clientes disponíveis</div>
                </q-card-section>
                <q-card-section>
                  <grid-clientes tipo="LIST" :loading="loadingClientes" tipoBotao="ADD" @on-select="addCliente" :clientes="filteredClientes" />
                </q-card-section>
              </q-card>
            </div>
            <div class="col-sm-6 col-xs-12 q-pr-sm q-pb-sm">
              <q-card>
                <q-card-section>
                  <div class="text-h6">Clientes ligados ao usuário</div>
                </q-card-section>
                <q-card-section>
                  <grid-clientes tipo="LIST" :loading="loadingClientesUsuario" tipoBotao="REMOVE" @on-select="removeCliente" :clientes="usuario.clientes" />
                </q-card-section>
              </q-card>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-form>
    <!-- <b-card class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ usuario }}</pre>
    </b-card> -->
  </div>
</template>

<script>
const usuarioModel = () => {
  return {
    _id: '',
    nome: '',
    cpf: '',
    email: '',
    nivel: 'USUARIO',
    habilitado: true,
    clientes: []
  }
}
import GridClientes from '../Cliente/GridClientes'
import { mask } from 'vue-the-mask'
import { getUser, getUserClientes, updateUser, createUser } from '../../services/usuario'
import { getClientes } from '../../services/clientes'
import { isValid } from 'cpf'
export default {
  name: 'form-usuario',
  props: {
    cpf: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loadingClientes: false,
      loadingClientesUsuario: false,
      usuario: usuarioModel(),
      clientes: [],
    }
  },
  mounted () {
    // this.usuario = this.usuarioSelecionado._id ? this.usuarioSelecionado : usuarioModel()
    this.getUsuario()
    this.getClientes()
    this.$refs.inputNome.focus()
  },
  methods: {
    async save () {
      try {
        const userData = Object.assign({}, this.usuario)
        if (this.usuario._id) {
          await updateUser(userData)
          this.$emit('on-save')
          this.$q.notify({
            color: 'green',
            position: 'top-right',
            icon: 'check',
            message: 'Usuário atualizado com sucesso!'
          })
        } else {
          await createUser(userData)
          this.$emit('on-save')
          this.$q.notify({
            color: 'green',
            position: 'top-right',
            icon: 'check',
            message: 'Usuário cadastrado com sucesso!'
          })
        }
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'negative',
          position: 'top-right',
          icon: 'report_problem',
          message: error.message
        })
      }
    },

    async getUsuario () {
      try {
        if (this.cpf) {
          const response = await getUser(this.cpf)
          this.usuario = response.user
          await this.getClientesUsuario()
        }
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'negative',
          position: 'top-right',
          icon: 'report_problem',
          message: error.message
        })
      }
    },

    async getClientesUsuario () {
      try {
        this.loadingClientesUsuario = true
        if (this.cpf) {
          const response = await getUserClientes(this.cpf)
          this.$set(this.usuario, 'clientes', response.map(x => Object.assign({}, x, { options: '' })))
        }
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'negative',
          position: 'top-right',
          icon: 'report_problem',
          message: error.message
        })
      } finally {
        this.loadingClientesUsuario = false
      }
    },

    async getClientes () {
      try {
        this.loadingClientes = true
        const response = await getClientes()
        this.clientes = response
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'negative',
          position: 'top-right',
          icon: 'report_problem',
          message: error.message
        })
      } finally {
        this.loadingClientes = false
      }
    },

    addCliente (cliente) {
      this.usuario.clientes = [...this.usuario.clientes, { ...cliente }]
    },

    removeCliente (usuario) {
      this.usuario.clientes = this.usuario.clientes.filter(x => x.codCliente !== usuario.codCliente)
    },

    validateCpf (cpf) {
      return isValid(cpf, false)
    }
  },
  computed: {
    filteredClientes () {
      return this.clientes
        .filter(cliente => this.usuario.clientes ? !this.usuario.clientes.find(x => x.codCliente === cliente.codCliente) : cliente )
    },

    filteredClientesLigados () {
      if (this.usuario.clientes) {
        return this.usuario.clientes
          .filter(cliente => this.textFilterClientesLigados ? cliente[this.searchClienteLigadoBy].toLowerCase().includes(this.textFilterClientesLigados.toLowerCase()) : cliente)
      }
      return []
    },

    isNovo () {
      return !this.usuario._id
    }
  },
  components: {
    GridClientes
  },
  directives: {
    mask
  }
}
</script>